import apiClient from './apiClient';

// In-memory cache for tags — the full tag list is ~91KB and rarely changes
// but is fetched on every library/search page load. A 5-minute TTL keeps
// it fresh while eliminating redundant API calls within a session.
const TAGS_CACHE_TTL_MS = 5 * 60 * 1000;
let tagsCache = null;
let tagsCacheTimestamp = 0;

export const getTags = async () => {
  const now = Date.now();
  if (tagsCache && (now - tagsCacheTimestamp) < TAGS_CACHE_TTL_MS) {
    return tagsCache;
  }
  const response = await apiClient.get('/api/tags');
  tagsCache = response.data;
  tagsCacheTimestamp = now;
  return response.data;
};

// Test helper — clears the in-memory cache so tests start with a clean state.
export const _clearTagsCache = () => {
  tagsCache = null;
  tagsCacheTimestamp = 0;
};

export const getTagBySlug = async (slug) => {
  const response = await apiClient.get(`/api/tags/slug/${slug}`);
  return response.data;
};

export const createTag = async (payload) => {
  const response = await apiClient.post('/api/tags', payload);
  return response.data;
};

export const updateTag = async (id, payload) => {
  const response = await apiClient.put(`/api/tags/${id}`, payload);
  return response.data;
};

export const deleteTag = async (id) => {
  await apiClient.delete(`/api/tags/${id}`);
};

export const getNovelsByTagId = async (id) => {
  const response = await apiClient.get(`/api/tags/${id}/novels`);
  return response.data;
};

export const getNovelsByTagSlug = async (slug) => {
  const response = await apiClient.get(`/api/novels`, {
    params: {
      tags: slug,
    },
  });
  return response.data;
};

export const getNovelsByTagSlugPaginated = async (slug, { page = 0, size = 20 } = {}) => {
  const response = await apiClient.get(`/api/tags/slug/${slug}/novels`, {
    params: { page, size },
  });
  return response.data;
};

// Admin-only: delete all tags with zero novel associations
export const deleteUnusedTags = async () => {
  const response = await apiClient.delete('/api/tags/unused');
  return response.data;
};

// Admin-only: merge source tag into target tag
export const mergeTags = async (sourceId, targetId) => {
  const response = await apiClient.post('/api/tags/merge', null, {
    params: { sourceId, targetId },
  });
  return response.data;
};
